import { FC, Dispatch, SetStateAction } from 'react';
import { Box, Input, FormControl, FormLabel, Select, Option } from '@mui/joy';
import { ASSETS_TYPES } from '../../../../config/consts';
import { TAssetType } from '../../../../config/requestTypes';

interface IFilters {
  assetFilter: string;
  assetNameFilter: string;
  setAssetFilter: Dispatch<SetStateAction<TAssetType>>;
  setAssetNameFilter: Dispatch<SetStateAction<string>>;
}

export const Filters: FC<IFilters> = ({
  assetFilter,
  assetNameFilter,
  setAssetFilter,
  setAssetNameFilter,
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
      <form
        style={{
          display: 'flex',
          gap: 10,
        }}
      >
        <FormControl>
          <FormLabel>Фильтр актива по типу</FormLabel>
          <Select
            value={assetFilter}
            placeholder="Выберите тип актива..."
            onChange={(_, newValue) => {
              if (newValue) setAssetFilter(newValue as TAssetType);
            }}
          >
            {ASSETS_TYPES.map((el, i) => (
              <Option value={el.value} key={`${el.value}-${i}`}>
                {el.label}
              </Option>
            ))}
          </Select>
        </FormControl>
        <FormControl>
          <FormLabel>Фильтр по названию</FormLabel>
          <Input
            value={assetNameFilter}
            onChange={(e) => setAssetNameFilter(e.target.value)}
          />
        </FormControl>
      </form>
    </Box>
  );
};
